import { Component, OnInit, ViewChild } from '@angular/core';
import { GridOptions } from 'ag-grid-community';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { CeqTableComponent } from 'src/app/ceq/common/ceq-table/ceq-table.component';
import { EditChildRendered } from '../../../common/renders/edit-child-rendered';
import { DeleteChildRendered } from '../../../common/renders/delete-child-rendered';
import { FiscalconfigService } from '../fiscalconfig.service';
import { GlobalFunctionsService } from 'src/app/ceq/common/functions/global-functions.service';


@Component({
  selector: 'app-fiscalconfig-list',
  templateUrl: './fiscalconfig-list.component.html',
  styleUrls: ['./fiscalconfig-list.component.scss']
})
export class FiscalconfigListComponent implements OnInit {

  constructor(private router: Router,
    private globalFunctionService: GlobalFunctionsService,
    private fiscalConfigService: FiscalconfigService) { }


  // ViewChild
  @ViewChild('CeqGrid', { static: false }) ceqGrid: CeqTableComponent;
  options: GridOptions;
  PageSizes = [10, 25, 50, 100, 1000];

  gridOptions = {
    context: this,
    frameworkComponents: {
      childEditRenderer: EditChildRendered,
      childDeleteMessageRenderer: DeleteChildRendered
    },
    suppressHorizontalScroll: true,
    onRowDoubleClicked(event: any) { },
    icons: {
      sortAscending: '<i class="fa fa-sort-up" style="margin-left:10px"></i>',
      sortDescending: '<i class="fa fa-sort-down" style="margin-left:10px"></i>',
      sortUnSort: '<i class="fa fa-sort" style="margin-left:10px"></i>'
    }
  }

  columnDefs = [
    {
      headerName: 'Llave',
      field: 'FiscalKey',
      width: 40,
      cellClass: 'align-start',
      sortable: true,
      unSortIcon: true,
      resizable: true,
      editable: false
    },
    {
      headerName: 'Valor',
      field: 'FiscalValue',
      width: 20,
      cellClass: 'align-start',
      sortable: true,
      unSortIcon: true,
      resizable: true,
      editable: false
    },
    {
      headerName: 'Última modificación',
      field: 'ModifiedAt',
      width: 20,
      cellClass: 'align-start',
      editable: false,
      sortable: true,
      unSortIcon: true,
      resizable: true,
      cellRenderer: (params: any) => moment(params.data.ModifiedAt).format('YYYY-MM-DD HH:mm:ss')
    },
    {
      headerName: 'Modificado por',
      field: 'ModifiedBy',
      width: 20,
      cellClass: 'align-start',
      resizable: true,
      editable: false
    },
    {
      headerName: 'Editar',
      field: 'icon',
      width: 5,
      cellRenderer: 'childEditRenderer',
      colId: 'params',
      cellClass: 'text-center',
      hide: false,
    },
    {
      headerName: 'Eliminar',
      field: 'icon',
      width: 5,
      cellRenderer: 'childDeleteMessageRenderer',
      colId: 'params',
      cellClass: 'text-center',
      hide: false,
    }
  ];


  ngOnInit(): void {
  }

  gridEmiter(GridOptions: GridOptions) {
    this.options = GridOptions;
    this.getFiscalConfig();
  }

  onPageSizeChange(value: number) {
    console.log(value);
  }

  btnAddClick() {
    this.router.navigate(['/tax/fiscalconfig/create']);
  }

  edit(row: any) {
    this.router.navigate(['/tax/fiscalconfig', row.data.IdFiscalConfig]);
  }

  async delete(row: any) {
	  const result = await this.globalFunctionService.messageBimbo("¿Desea eliminar la configuración " + row.data.FiscalKey + "?", 'question1', 'Confirmacion');
      if (result) {
        this.fiscalConfigService.deleteFiscalConfig(row.data.IdFiscalConfig).subscribe(async data => {
          console.log("result", data);
		      await this.globalFunctionService.messageBimbo('La configuración se eliminó correctamente.', 'success', '¡Éxito!');
        }, async (error) => {
          console.log("error", error);
		      await this.globalFunctionService.messageBimbo(error.error, 'error', '¡Error!');
        }, () => {
          this.getFiscalConfig();
        });
      }
  }


  getFiscalConfig() {
    this.fiscalConfigService.getFiscalConfigList().subscribe(data => {
      this.ceqGrid.data = data;
    });
  }

}
